export default __webpack_public_path__ + "static/media/robbie_gillies.56b0d950.jpg";